import { defineStore } from 'pinia';

export const useAppStore = defineStore('store', {
    state: () => ({
        currentTheme: 'dark',
        globalFont: 'Inter',
        deviceType: null as string | null,
        mixedTheme: true,
        rememberMe: false,
        mainDrawerDefault: false,
        page: 1,
        pageSize: 8,
        slashSearch: false,
        sort: null as string | null,
        query: null,
        equipmentType: [] as string[],
        fuelType: [] as string[],
        size: [] as string[],
        brand: [] as string[],
        availability: [] as string[],
        search: null,
        password: null,

        // Secure Variables
        isAuthenticated: false,
        layoutVertical: true,
        dcFluidity: false,
        backgroundTheme: 'none',
        wipNotice: true,
        cookieNotice: true,
        balancePrivacy: false,
    }),
    persist: true,
});
